var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSensha(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002455;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(195 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(-195 65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-190.387,93.32V89.264l4.228-2.812,4.972-5.159h12.924l3.65,5.159v7.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-164.613,94.331h-.008l-25.774-.261a.75.75,0,0,1-.742-.75V89.264a.75.75,0,0,1,.335-.624l4.16-2.767,4.915-5.1a.75.75,0,0,1,.54-.23h12.924a.75.75,0,0,1,.612.317l3.65,5.159a.75.75,0,0,1,.138.433v7.128a.75.75,0,0,1-.222.533A.75.75,0,0,1-164.613,94.331Zm-25.024-1.753,24.274.246V86.691l-3.288-4.647h-12.217l-4.75,4.929a.751.751,0,0,1-.125.1l-3.894,2.589Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-186.159,86.452"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(-186.104 90.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(-186.104 90.164)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(-173.738 90.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(-173.738 90.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-174.707,87.2h-11.452V85.7h10.7V81.629h1.5v4.823A.75.75,0,0,1-174.707,87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-164.613,87.2h-7.263a.75.75,0,0,1-.75-.75V81.629h1.5V85.7h6.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.836,0h6.1A3.836,3.836,0,0,1,13.77,3.836v.737a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.836A3.836,3.836,0,0,1,3.836,0Z",
    transform: "translate(-184.343 68.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.836-.75h6.1A4.591,4.591,0,0,1,14.52,3.836v.737a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V3.836A4.591,4.591,0,0,1,3.836-.75ZM13.02,3.822A3.089,3.089,0,0,0,9.934.75h-6.1A3.089,3.089,0,0,0,.75,3.822Z",
    transform: "translate(-184.343 68.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,3.67a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.92A.75.75,0,0,1,0,3.67Z",
    transform: "translate(-177.458 75.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,1.25A.754.754,0,0,1-.13,1.239.75.75,0,0,1-.739.37l.088-.5A.75.75,0,0,1,.218-.739.75.75,0,0,1,.827.13l-.088.5A.75.75,0,0,1,0,1.25Z",
    transform: "translate(-181.662 78.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,1.406A.754.754,0,0,1-.13,1.395.75.75,0,0,1-.739.526L-.623-.13A.75.75,0,0,1,.246-.739.75.75,0,0,1,.854.13L.739.786A.75.75,0,0,1,0,1.406Z",
    transform: "translate(-181.263 75.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,3.332a.749.749,0,0,1-.256-.045A.75.75,0,0,1-.7,2.326L.235-.257A.75.75,0,0,1,1.2-.7a.75.75,0,0,1,.448.961L.7,2.839A.75.75,0,0,1,0,3.332Z",
    transform: "translate(-188.365 82.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,4.584a.749.749,0,0,1-.256-.045A.75.75,0,0,1-.7,3.577L.691-.257A.75.75,0,0,1,1.652-.7.75.75,0,0,1,2.1.257L.7,4.09A.75.75,0,0,1,0,4.584Z",
    transform: "translate(-186.469 75.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.088,1.252A.75.75,0,0,1-.65.632L-.739.13A.75.75,0,0,1-.13-.739.75.75,0,0,1,.739-.13l.088.5a.75.75,0,0,1-.608.869A.755.755,0,0,1,.088,1.252Z",
    transform: "translate(-173.343 78.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.094,1.29A.75.75,0,0,1-.643.67l-.1-.54A.75.75,0,0,1-.13-.739.75.75,0,0,1,.739-.13l.1.54a.75.75,0,0,1-.608.869A.755.755,0,0,1,.094,1.29Z",
    transform: "translate(-173.769 75.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.063,3.67a.75.75,0,0,1-.7-.494L-.7.257A.75.75,0,0,1-.257-.7.75.75,0,0,1,.7-.257l1.063,2.92a.751.751,0,0,1-.7,1.007Z",
    transform: "translate(-169.843 75.874)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSensha);
export default __webpack_public_path__ + "static/media/icon_sensha.6e2cecd9275080c78c32c9234459c2d7.svg";
export { ForwardRef as ReactComponent };